import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";
import { QuickFilterOption } from "../../../reusable-components/QuickFilter/interfaces";

import useAbortableLoadResponse from "../../../custom-hooks/useAbortableLoadResponse/useAbortableLoadResponse";
import { EventTypesApiService } from "../../../services/event-types/event-types-api.service";

import { EventTypeDTO } from "../../../models/event-types/event-type-dto";

import { Props, EventTypesOptionValue, EventTypeQuickFilter } from "./interfaces";

export const EventTypeQuickfilter = <Q extends EventTypeQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.event_types"; // tRP - translation root path

  const [options, setOptions] = useState<QuickFilterOption<EventTypesOptionValue>[]>([
    // DEFAULT VALUE ???
    { name: t(`${tRP}.all_types`), value: { eventTypeIds: [] } },
  ]);

  const { response } = useAbortableLoadResponse<EventTypeDTO>(EventTypesApiService, {});

  useEffect(() => {
    if (!!response?.items.length) {
      const newOptions = response.items.map(({ name, id }) => ({
        name,
        value: { eventTypeIds: [id] },
      }));

      setOptions((options) => [...options, ...newOptions]);
    }
  }, [response?.items]);

  return (
    <QuickFilter
      options={options}
      quickFilters={quickFilters}
      quickFilter="eventTypes"
      handleChangeQuickFilter={handleChangeQuickFilters}
      defaultLabel={t(`${tRP}.default_label`)}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
    />
  );
};

export default EventTypeQuickfilter;
